<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >人才档案列表</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item title="总部" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    style="width: 140px"
                                    transfer
                                    v-model="data.division"
                                    :options="formInput.hqOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    :options="toolbar.allStatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="部署平台" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.realPlatform"
                                    placeholder="全部"
                                    :options="formInput.planPlatform"
                                    clearable
                                    style="width: 100px"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="员工类型" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.empType"
                                    placeholder="全部"
                                    clearable
                                    style="width: 90px"
                                >
                                    <vxe-option
                                        value="L01"
                                        label="作业型"
                                    ></vxe-option>
                                    <vxe-option
                                        value="L02"
                                        label="助手型"
                                    ></vxe-option>
                                    <vxe-option
                                        value="L03"
                                        label="专家型"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="运行方式" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.deployType"
                                    placeholder="全部"
                                    clearable
                                    style="width: 70px"
                                >
                                    <vxe-option
                                        value="平台"
                                        label="平台"
                                    ></vxe-option>
                                    <vxe-option
                                        value="本地"
                                        label="本地"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入数字员工编号、数字员工名称、业务人员"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="上岗日期" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.onboardStartDate"
                                    type="date"
                                    placeholder="开始日期"
                                    clearable
                                    transfer
                                    style="width: 130px"
                                ></vxe-input>
                                <span style="margin: 0 6px">至</span>
                                <vxe-input
                                    v-model="data.onboardEndDate"
                                    type="date"
                                    placeholder="结束日期"
                                    clearable
                                    transfer
                                    style="width: 130px"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="退役日期" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.retireStartDate"
                                    type="date"
                                    placeholder="开始日期"
                                    clearable
                                    transfer
                                    style="width: 130px"
                                ></vxe-input>
                                <span style="margin: 0 6px">至</span>
                                <vxe-input
                                    v-model="data.retireEndDate"
                                    type="date"
                                    placeholder="结束日期"
                                    clearable
                                    transfer
                                    style="width: 130px"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button @click="exportDataEvent"
                                    >导出</vxe-button
                                >
                                <vxe-button @click="showChangeHis"
                                    >变更历史</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        ref="xTable1"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="查看" width="50">
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-search"
                                    @click="editAdminEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column align="center" title="状态" width="120">
                            <template #default="{ row }">
                                <vxe-button
                                    v-bind:class="{
                                        active: row.AuditStatus === '已审核',
                                        error: row.AuditStatus.includes('驳回'),
                                    }"
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.AuditStatus }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="PubState"
                            :visible="false"
                            title="发布阶段"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="empNo"
                            title="数字员工编号"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="数字员工名称"
                            width="220"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="processDesc"
                            title="工作场景描述"
                            width="140"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="FPCount"
                            title="FP功能点数"
                            width="120"
                            show-overflow
                            resizable
                            sortable
                            ><template #default="{ row }">
                                <vxe-button
                                    :style="{
                                        color: '#1890ff',
                                        textDecoration: 'underline',
                                    }"
                                    type="text"
                                    @click="showFPEstimate(row)"
                                    >{{ row.FPCount }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="empTypeName"
                            title="数字员工类型"
                            width="120"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="introduction"
                            title="数字员工简介"
                            width="120"
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessID"
                            title="开发编号"
                            width="100"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="realPlatformName"
                            title="部署平台"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="otherPlatform"
                            title="其他部署平台"
                            width="140"
                            sortable
                            show-overflow
                            resizable
                        ></vxe-column>
                        <vxe-column
                            field="deployType"
                            title="运行方式"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="localAppType"
                            title="本地程序类型"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="业务人员"
                            width="100"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="empCode"
                            title="工号"
                            width="100"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="divisionName"
                            title="总部"
                            width="120"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="techName"
                            title="辅导老师"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="sceneName"
                            title="场景组担当"
                            width="140"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="上岗申请时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="AuditTime"
                            title="上岗审批时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="MachineName"
                            title="虚拟机"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ManSingleTime"
                            title="Before-人工每次耗时(分钟)"
                            width="200"
                        ></vxe-column>
                        <vxe-column
                            field="ManFrequency"
                            title="Before-人工每月次数"
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="RobotSingleTime"
                            title="After-每次耗时(分钟)"
                            width="200"
                            sorable
                        ></vxe-column>
                        <vxe-column
                            field="RobotMonthRun"
                            title="After-每月次数"
                            width="140"
                        ></vxe-column>
                        <vxe-column
                            field="DevelopTime"
                            title="开发时间(小时)"
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="SingleSaveTime"
                            title="单次节省-时间(分钟)"
                            show-overflow
                            width="180"
                        ></vxe-column>
                        <vxe-column
                            field="operationNodes"
                            title="总任务节点数"
                            width="120"
                        ></vxe-column>
                        <vxe-column
                            field="replaceNodes"
                            title="替代节点数"
                            width="120"
                        ></vxe-column>
                        <vxe-column
                            field="CreateMan"
                            title="申请人"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="CreateManEmail"
                            title="申请人邮箱"
                            width="180"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="retireApplyTime"
                            title="退役申请时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="retireAuditTime"
                            title="退役审批时间"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="UserID"
                            title="UserID"
                            show-overflow
                            width="100"
                            :visible="false"
                            sortable
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        :page-sizes="[
                            10,
                            20,
                            100,
                            200,
                            { label: '全部数据', value: 10000 },
                        ]"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <!--上岗申请 -->
            <vxe-modal
                v-model="formInput.isShow"
                @close="closeWinEvent"
                :title="formInput.title"
                width="840"
                height="600"
                show-zoom
                resize
                remember
                show-footer
            >
                <template #default>
                    <a-tabs v-model:activeKey="activeKey">
                        <a-tab-pane key="1" tab="申请单">
                            <vxe-form
                                :data="formInput.formData"
                                :rules="formInput.formRules"
                                title-align="right"
                                ref="rForm"
                                title-width="60"
                            >
                                <vxe-form-item
                                    title="基本信息"
                                    span="24"
                                    title-align="left"
                                    title-width="200px"
                                    :title-prefix="{
                                        icon: 'fa fa-address-card-o',
                                    }"
                                ></vxe-form-item>
                                <vxe-form-item
                                    title="数字员工编号"
                                    field="empNo"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="formInput.formData.empNo"
                                            readonly
                                            placeholder="请输入数字员工编号"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="数字员工名称"
                                    field="ProcessName"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.ProcessName
                                            "
                                            placeholder="请输入数字员工名称"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="工作场景描述"
                                    field="processDesc"
                                    span="24"
                                    title-width="120px"
                                >
                                    <vxe-textarea
                                        v-model="formInput.formData.processDesc"
                                        placeholder="填写（流程、痛点、解决方案）"
                                        maxlength="500"
                                        show-word-count
                                        :disabled="formInput.allInputDisable"
                                    ></vxe-textarea>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="场景业务价值"
                                    field="sceneBussValue"
                                    span="24"
                                    title-width="120px"
                                >
                                    <vxe-textarea
                                        v-model="
                                            formInput.formData.sceneBussValue
                                        "
                                        placeholder="填写（体验、收益、效率、效果）"
                                        maxlength="500"
                                        show-word-count
                                        :disabled="formInput.allInputDisable"
                                    ></vxe-textarea>
                                </vxe-form-item>

                                <vxe-form-item
                                    title="申请人(孵化者)"
                                    field="CreateManName"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.CreateManName
                                            "
                                            placeholder="请输入姓名"
                                            readonly
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="总部"
                                    field="division"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.division
                                            "
                                            placeholder="请输入总部"
                                            readonly
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="数字员工类型"
                                    field="empType"
                                    span="12"
                                    title-width="140px"
                                >
                                    <template #default>
                                        <vxe-select
                                            transfer
                                            v-model="formInput.formData.empType"
                                            :options="formInput.digitalTypes"
                                            placeholder="请选择数字员工类型"
                                            readonly
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        >
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="数字员工简介"
                                    field="introduction"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.introduction
                                            "
                                            clearable
                                            placeholder="请输入数字员工简介"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    title="辅导老师"
                                    field="techUID"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-select
                                            transfer
                                            v-model="formInput.formData.techUID"
                                            :options="formInput.allTechs"
                                            placeholder="请选择辅导老师"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        >
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="场景组担当"
                                    field="sceneUID"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-select
                                            transfer
                                            v-model="
                                                formInput.formData.sceneUID
                                            "
                                            :options="formInput.allScenes"
                                            placeholder="请选择场景组担当"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        >
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="业务人员"
                                    field="UserNameEmail"
                                    span="10"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.UserNameEmail
                                            "
                                            readonly
                                            placeholder="请选择业务人员"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item span="2">
                                    <template #default>
                                        <vxe-button
                                            @click="selectUser(2)"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            >选择</vxe-button
                                        >
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="发布阶段"
                                    field="PubState"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-select
                                            v-model="
                                                formInput.formData.PubState
                                            "
                                            @change="onSelectPubState"
                                            placeholder="请选择发布阶段"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            clearable
                                        >
                                            <vxe-option
                                                value="1"
                                                label="测试发布"
                                            ></vxe-option>
                                            <vxe-option
                                                value="2"
                                                label="生产发布"
                                            ></vxe-option>
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="部署平台"
                                    field="realPlatform"
                                    span="12"
                                    title-width="140px"
                                >
                                    <template #default>
                                        <vxe-select
                                            transfer
                                            v-model="
                                                formInput.formData.realPlatform
                                            "
                                            :options="formInput.planPlatform"
                                            placeholder="请选择实际部署平台"
                                            @change="onSelectPubState"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        >
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    :title="otherPlatformLabel"
                                    field="otherPlatform"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.otherPlatform
                                            "
                                            clearable
                                            :placeholder="otherPlatformLabel"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="外部AppID"
                                    field="otherAppID"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.otherAppID
                                            "
                                            clearable
                                            placeholder="请输入外部AppID.例如Dify应用ID"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="数字员工版本"
                                    field="empVersion"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.empVersion
                                            "
                                            clearable
                                            placeholder="请输入数字员工版本.例如：V1.0"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    :visible="isDifyDE"
                                    title="公开范围"
                                    field="difyViewType"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-select
                                            v-model="
                                                formInput.formData.difyViewType
                                            "
                                            @change="onDifyViewTypeChange"
                                            placeholder="请选择发公开范围"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            empty-value=""
                                            @clear="
                                                formInput.formData.difyViewType =
                                                    ''
                                            "
                                        >
                                            <vxe-option
                                                value="1"
                                                label="个人"
                                            ></vxe-option>
                                            <vxe-option
                                                value="2"
                                                label="总部"
                                            ></vxe-option>
                                            <vxe-option
                                                value="3"
                                                label="全部"
                                            ></vxe-option>
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    :visible="isDifyDE"
                                    title="公开总部"
                                    field="difyViewDivsion"
                                    span="12"
                                    title-width="120px"
                                >
                                    <template #default>
                                        <vxe-select
                                            v-model="
                                                formInput.formData
                                                    .difyViewDivsion
                                            "
                                            placeholder="请选择公开总部"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            clearable
                                            multiple
                                            empty-value=""
                                            @clear="
                                                formInput.formData.difyViewDivsion =
                                                    ''
                                            "
                                            :options="formInput.hqOptions"
                                        >
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="运行方式"
                                    field="deployType"
                                    span="12"
                                    title-width="120px"
                                    :title-prefix="{
                                        content:
                                            '平台：程序运行在服务器端，可在本网站直接触发或跳转执行（如派神易、UiPath、Python、Dify）\n本地：程序运行在个人电脑上（如本地 Python、VBA 脚本等），无法通过本网站触发执行，Out System 等外部系统需选择本地',
                                        icon: 'vxe-icon-question-circle-fill',
                                    }"
                                >
                                    <template #default>
                                        <vxe-select
                                            transfer
                                            v-model="
                                                formInput.formData.deployType
                                            "
                                            placeholder="请选择运行方式"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            @change="onSelectDeployType"
                                        >
                                            <vxe-option
                                                value="平台"
                                                label="平台"
                                            ></vxe-option>
                                            <vxe-option
                                                value="本地"
                                                label="本地"
                                            ></vxe-option>
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="版本变更备注"
                                    field="verHistory"
                                    span="12"
                                    title-width="120px"
                                    v-if="false"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.verHistory
                                            "
                                            clearable
                                            placeholder="请输入版本变更备注"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    title="本地运行原因"
                                    field="localReason"
                                    span="24"
                                    title-width="120px"
                                    :visible="isShowDeployType"
                                >
                                    <template #default>
                                        <vxe-textarea
                                            v-model="
                                                formInput.formData.localReason
                                            "
                                            placeholder="请输入本地运行原因"
                                            maxlength="1000"
                                            show-word-count
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        ></vxe-textarea>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="本地程序类型"
                                    field="localAppType"
                                    span="12"
                                    title-width="120px"
                                    :visible="isShowDeployType"
                                >
                                    <template #default>
                                        <vxe-select
                                            transfer
                                            v-model="
                                                formInput.formData.localAppType
                                            "
                                            placeholder="请选择本地程序类型"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            @change="onSelectLocalAppType"
                                        >
                                            <vxe-option
                                                v-for="option in localAppTypeOptions"
                                                :key="option.value"
                                                :value="option.value"
                                                :label="option.label"
                                            ></vxe-option>
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="4"
                                    :item-render="{}"
                                    :visible="
                                        isShowDeployType && isShowLocalAppPath
                                    "
                                >
                                    <template #default="">
                                        <vxe-button
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            @click="generateBatEntry"
                                            icon="fa fa-file"
                                            >生成注册文件</vxe-button
                                        >
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="4"
                                    :item-render="{}"
                                    :visible="
                                        isShowDeployType && isShowLocalAppPath
                                    "
                                >
                                    <template #default="">
                                        <vxe-button
                                            style="margin-left: 10px"
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            @click="execLocalFile"
                                            icon="fa fa-play"
                                            >测试执行</vxe-button
                                        >
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="4"
                                    :item-render="{}"
                                    :visible="
                                        isShowDeployType && isShowLocalAppPath
                                    "
                                >
                                    <a
                                        href="javascript:void(0);"
                                        @click="viewInstructions"
                                        >填写说明</a
                                    >
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="12"
                                    :item-render="{}"
                                    :visible="
                                        ['4', '5', '6', '7', '8'].includes(
                                            formInput.formData.localAppType
                                        ) && isShowDeployType
                                    "
                                >
                                    <span style="color: red">
                                        {{
                                            this.getLocalAppTypeTip(
                                                this.formInput.formData
                                                    .localAppType
                                            )
                                        }}
                                    </span>
                                </vxe-form-item>

                                <vxe-form-item
                                    :title="localAppPathLabel"
                                    field="localAppPath"
                                    span="22"
                                    title-width="120px"
                                    :visible="
                                        isShowDeployType && isShowLocalAppPath
                                    "
                                >
                                    <template #default="{ data }">
                                        <vxe-input
                                            v-model="data.localAppPath"
                                            :placeholder="localAppPlaceholder"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                    :visible="
                                        isShowDeployType && isShowLocalAppPath
                                    "
                                >
                                    <template #default=""> </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    :title="localExeFileLabel"
                                    field="localExeFile"
                                    span="22"
                                    title-width="120px"
                                    :visible="
                                        isShowDeployType && isShowLocalExeFile
                                    "
                                >
                                    <template #default="{ data }">
                                        <vxe-input
                                            v-model="data.localExeFile"
                                            :placeholder="localFilePlaceholder"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                    :visible="
                                        isShowDeployType && isShowLocalExeFile
                                    "
                                >
                                    <template #default=""> </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    :title="localExeParamLabel"
                                    field="localExeParam"
                                    span="22"
                                    title-width="120px"
                                    :visible="
                                        isShowDeployType && isShowLocalExeParam
                                    "
                                >
                                    <template #default="{ data }">
                                        <vxe-input
                                            v-model="data.localExeParam"
                                            placeholder="请输入程序参数"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="生产发布填写"
                                    span="24"
                                    title-align="left"
                                    title-width="200px"
                                    :title-prefix="{ icon: 'fa fa-list-alt' }"
                                ></vxe-form-item>

                                <vxe-form-item
                                    title="Before-人工每次耗时(分钟)"
                                    field="ManSingleTime"
                                    span="12"
                                    title-width="200px"
                                >
                                    <template #default>
                                        <vxe-input
                                            type="number"
                                            min="0"
                                            clearable
                                            v-model="
                                                formInput.formData.ManSingleTime
                                            "
                                            placeholder="请输入Before-人工每次耗时(分钟)"
                                            @change="updateSingleSaveTime"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="Before-人工每月次数"
                                    field="ManFrequency"
                                    span="12"
                                    title-width="200px"
                                >
                                    <template #default>
                                        <vxe-input
                                            type="number"
                                            min="0"
                                            clearable
                                            v-model="
                                                formInput.formData.ManFrequency
                                            "
                                            placeholder="请输入Before-人工每月次数"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="After-每次耗时(分钟)"
                                    field="RobotSingleTime"
                                    span="12"
                                    title-width="200px"
                                >
                                    <template #default>
                                        <vxe-input
                                            type="number"
                                            min="0"
                                            clearable
                                            v-model="
                                                formInput.formData
                                                    .RobotSingleTime
                                            "
                                            placeholder="请输入After-每次耗时(分钟)"
                                            @change="updateSingleSaveTime"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="After-每月次数"
                                    field="RobotMonthRun"
                                    span="12"
                                    title-width="200px"
                                >
                                    <template #default>
                                        <vxe-input
                                            type="number"
                                            min="0"
                                            clearable
                                            v-model="
                                                formInput.formData.RobotMonthRun
                                            "
                                            placeholder="请输入After-每月次数"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="单次节省-时间(分钟)"
                                    field="SingleSaveTime"
                                    span="12"
                                    title-width="200px"
                                >
                                    <template #default>
                                        <vxe-input
                                            type="number"
                                            min="0"
                                            clearable
                                            v-model="
                                                formInput.formData
                                                    .SingleSaveTime
                                            "
                                            placeholder="请输入单次节省-时间(分钟)"
                                            disabled="true"
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="开发时长(小时)"
                                    field="DevelopTime"
                                    span="12"
                                    title-width="200px"
                                >
                                    <template #default>
                                        <vxe-input
                                            type="number"
                                            min="0"
                                            clearable
                                            v-model="
                                                formInput.formData.DevelopTime
                                            "
                                            placeholder="请输入数字员工开发时间"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="总任务节点数"
                                    field="operationNodes"
                                    span="12"
                                    title-width="220px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData
                                                    .operationNodes
                                            "
                                            type="number"
                                            min="0"
                                            clearable
                                            placeholder="请输入总任务节点数"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="数字员工替代节点数"
                                    field="replaceNodes"
                                    span="10"
                                    title-width="200px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInput.formData.replaceNodes
                                            "
                                            type="number"
                                            min="0"
                                            clearable
                                            placeholder="请输入数字员工替代节点数"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                >
                                    <a
                                        href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1737"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        说明
                                    </a>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="附件"
                                    span="24"
                                    title-align="left"
                                    title-width="200px"
                                    :title-prefix="{ icon: 'fa fa-paperclip' }"
                                ></vxe-form-item>
                                <vxe-form-item
                                    title="程序包"
                                    field="fPathPackage"
                                    span="18"
                                    :item-render="{}"
                                    title-width="120px"
                                >
                                    <template #default="{ data }">
                                        <vxe-input
                                            v-model="data.fPathPackage"
                                            placeholder="请选择程序包"
                                            readonly
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                >
                                    <template #default="">
                                        <vxe-button
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            @click="insertPackageEvent"
                                            >浏览</vxe-button
                                        >
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="4"
                                    :item-render="{}"
                                >
                                    <a
                                        v-if="isShowPackageLink"
                                        href="javascript:void(0);"
                                        @click="downloadFile(1)"
                                        >下载</a
                                    >
                                </vxe-form-item>
                                <vxe-form-item
                                    title="设计文档"
                                    field="fPathPdd"
                                    span="18"
                                    :item-render="{}"
                                    title-width="120px"
                                >
                                    <template #default="{ data }">
                                        <vxe-input
                                            v-model="data.fPathPdd"
                                            placeholder="请选择设计文档"
                                            readonly
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                >
                                    <template #default="">
                                        <vxe-button
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                            @click="insertPDDEvent"
                                            >浏览</vxe-button
                                        >
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                >
                                    <a
                                        v-if="isShowPDDLink"
                                        href="javascript:void(0);"
                                        @click="downloadFile(2)"
                                        >下载</a
                                    >
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                >
                                    <a
                                        v-if="!isShowPDDLink"
                                        href="javascript:void(0);"
                                        @click="downloadFile(4)"
                                        >模板</a
                                    >
                                </vxe-form-item>
                                <vxe-form-item
                                    title="数字员工照片"
                                    field="fPathPhoto"
                                    span="18"
                                    :item-render="{}"
                                    title-width="120px"
                                >
                                    <template #default="{ data }">
                                        <vxe-input
                                            v-model="data.fPathPhoto"
                                            placeholder="请选择数字员工照片"
                                            readonly
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                >
                                    <template #default="">
                                        <vxe-button
                                            @click="insertPhotoEvent"
                                            :disabled="
                                                !formInput.formData.isPro ||
                                                formInput.allInputDisable
                                            "
                                        >
                                            浏览
                                        </vxe-button>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                >
                                    <a
                                        v-if="isShowPhotoLink"
                                        href="javascript:void(0);"
                                        @click="downloadFile(6)"
                                        >下载</a
                                    >
                                </vxe-form-item>
                                <vxe-form-item
                                    title=""
                                    span="2"
                                    :item-render="{}"
                                >
                                </vxe-form-item>
                                <vxe-form-item
                                    span="24"
                                    title-align="left"
                                    title-width="600px"
                                    :title-prefix="{
                                        icon: 'fa fa-check-circle-o',
                                    }"
                                    v-if="formInput.formData.AuditStatus == '1'"
                                >
                                    <template #title>
                                        <span style="color: red">审核意见</span>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="虚拟机"
                                    field="MachineName"
                                    span="12"
                                    title-width="100px"
                                    v-if="formInput.formData.AuditStatus == '1'"
                                >
                                    <template #default>
                                        <vxe-select
                                            v-model="
                                                formInput.formData.MachineName
                                            "
                                            :options="toolbar.macOptions"
                                            placeholder="请选择虚拟机"
                                            clearable
                                            :disabled="
                                                formInput.allInputDisable
                                            "
                                        >
                                        </vxe-select>
                                    </template>
                                </vxe-form-item>
                            </vxe-form>
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="频次变更历史">
                            <vxe-table
                                stripe
                                class="mytable-scrollbar"
                                :data="historyDataFrequency"
                                :height="330"
                                show-overflow
                                :row-config="{
                                    height: 36,
                                    isHover: true,
                                    isCurrent: true,
                                }"
                            >
                                <vxe-column
                                    type="seq"
                                    title="序号"
                                    width="50"
                                ></vxe-column>

                                <vxe-column
                                    field="statusName"
                                    title="状态"
                                    width="120"
                                    show-overflow
                                >
                                    <template #default="{ row }">
                                        <vxe-button
                                            v-bind:class="{
                                                active:
                                                    row.statusName === '已审核',
                                                error: row.statusName.includes(
                                                    '驳回'
                                                ),
                                            }"
                                            type="text"
                                            @click="showAuditList(row)"
                                            >{{ row.statusName }}
                                        </vxe-button>
                                    </template>
                                </vxe-column>

                                <vxe-column
                                    field="ProcessName"
                                    title="数字员工名称"
                                    width="180"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="ProcessID"
                                    title="开发编号"
                                    width="130"
                                    show-overflow
                                ></vxe-column>
                                <vxe-column
                                    field="oldManSingleTime"
                                    title="原人工每次耗时"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="ManSingleTime"
                                    title="新人工每次耗时"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="oldManFrequency"
                                    title="原人工每月次数"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="ManFrequency"
                                    title="新人工每月次数"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="oldDevelopTime"
                                    title="原开发时长"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="DevelopTime"
                                    title="新开发时长"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="oldRobotSingleTime"
                                    title="原机器人单次耗时"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="RobotSingleTime"
                                    title="新机器人单次耗时"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="oldRobotMonthRun"
                                    title="原机器人每月次数"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="RobotMonthRun"
                                    title="新机器人每月次数"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="creationTime"
                                    title="创建日期"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="UserName"
                                    title="申请人"
                                    width="100"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="changeReason"
                                    title="变更原因"
                                    min-width="200"
                                    show-overflow
                                ></vxe-column>
                            </vxe-table>
                        </a-tab-pane>
                        <a-tab-pane key="3" tab="员工类型变更历史">
                            <vxe-table
                                stripe
                                class="mytable-scrollbar"
                                :data="historyDataEmpType"
                                :height="330"
                                show-overflow
                                :row-config="{
                                    height: 36,
                                    isHover: true,
                                    isCurrent: true,
                                }"
                            >
                                <vxe-column
                                    type="seq"
                                    title="序号"
                                    width="50"
                                ></vxe-column>
                                <vxe-column
                                    field="statusName"
                                    title="状态"
                                    width="120"
                                    show-overflow
                                >
                                    <template #default="{ row }">
                                        <vxe-button
                                            v-bind:class="{
                                                active:
                                                    row.statusName === '已审核',
                                                error: row.statusName.includes(
                                                    '驳回'
                                                ),
                                            }"
                                            type="text"
                                            @click="showAuditList(row)"
                                            >{{ row.statusName }}
                                        </vxe-button>
                                    </template>
                                </vxe-column>

                                <vxe-column
                                    field="ProcessName"
                                    title="数字员工名称"
                                    width="180"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="ProcessID"
                                    title="开发编号"
                                    width="130"
                                    show-overflow
                                ></vxe-column>
                                <vxe-column
                                    field="oldempTypeName"
                                    title="原数字员工类型"
                                    width="150"
                                    show-overflow
                                ></vxe-column
                                ><vxe-column
                                    field="empTypeName"
                                    title="新数字员工类型"
                                    width="150"
                                    show-overflow
                                ></vxe-column>
                                <vxe-column
                                    field=""
                                    title="附件"
                                    width="100"
                                    show-overflow
                                >
                                    <template #default="{ row }">
                                        <vxe-button
                                            type="text"
                                            @click="downloadFile(row)"
                                        >
                                            下载
                                        </vxe-button>
                                    </template>
                                </vxe-column>
                                <vxe-column
                                    field="creationTime"
                                    title="创建日期"
                                    width="150"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="UserName"
                                    title="创建人"
                                    width="100"
                                    show-overflow
                                ></vxe-column>

                                <vxe-column
                                    field="changeReason"
                                    title="变更原因"
                                    min-width="200"
                                    show-overflow
                                ></vxe-column>
                            </vxe-table>
                        </a-tab-pane>
                    </a-tabs>
                </template>
                <template #footer v-if="isViewFooter">
                    <div style="text-align: center; width: 100%">
                        <vxe-button
                            :loading="submitting"
                            @click="save"
                            icon="fa fa-save"
                            status="success"
                            >保存
                        </vxe-button>
                        <vxe-button
                            v-if="false"
                            :loading="submitting"
                            @click="submit"
                            icon="fa fa-check"
                            status="primary"
                            >提交
                        </vxe-button>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
                <template #default>
                    <div>
                        <vxe-form :data="userTablePager">
                            <vxe-form-item
                                title="关键字"
                                field="searchKey"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.searchKey"
                                        placeholder="请输入姓名或邮箱"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findUserData"
                                        @keyup.enter="findUserData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        status="primary"
                                        @click="confirmSelectUser"
                                        >确定</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="24">
                                <template #title>
                                    <span>已选(</span
                                    ><span style="color: red">双击选择</span
                                    ><span>)</span>
                                </template>
                                <template #default>
                                    <div v-if="formInput.userSelType == 1">
                                        <template
                                            v-for="(item, index) in formInput
                                                .formData.DevelopIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                        </template>
                                    </div>
                                    <div v-else-if="formInput.userSelType == 2">
                                        <template
                                            v-for="(item, index) in formInput
                                                .formData.UserIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                            <va-icon
                                                class="icon-left input-icon"
                                                @click="clearUser(item.ID)"
                                                name="clear"
                                            />
                                        </template>
                                    </div>
                                    <div v-else-if="formInput.userSelType == 3">
                                        <template
                                            v-for="(
                                                item, index
                                            ) in formInputRetire.formData
                                                .leaderIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                        </template>
                                    </div>
                                    <div v-if="formInput.userSelType == 4">
                                        <template
                                            v-for="(
                                                item, index
                                            ) in formInputAddMan.formData
                                                .UserIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                            <va-icon
                                                class="icon-left input-icon"
                                                @click="
                                                    clearUserAddMan(item.ID)
                                                "
                                                name="clear"
                                            />
                                        </template>
                                    </div>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtUser"
                            ref="xTableUser"
                            height="300"
                            @cell-dblclick="chooseUser"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Uid"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobZb"
                                title="总部"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobName"
                                title="部门"
                                width="120"
                                show-overflow
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="UserMail"
                                title="邮箱"
                                width="200"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="Id"
                                title="Id"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="userTablePager.currentPage"
                            v-model:page-size="userTablePager.pageSize"
                            :total="userTablePager.totalResult"
                            @page-change="userListPageChange"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="数字员工变更申请记录"
                v-model="isShowChangeApplyList"
                width="1100"
                height="600"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <div style="height: 100%; width: 100%">
                        <ChangeApplyList
                            ref="changeApplyListRef"
                        ></ChangeApplyList>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
    <FPEstimate ref="fpestimateRef"></FPEstimate>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";
import { VXETable } from "vxe-table";
import XEUtils from "xe-utils";
import MyAuditLine from "../myPlug/MyAuditLine";
import FPEstimate from "../requireManage/FPEstimate";
import ChangeApplyList from "./ChangeApplyList";
export default {
    name: "TalentProfile",
    components: { MyAuditLine, FPEstimate, ChangeApplyList },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });

        const userTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });
        const reqTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });
        const updatePackagePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            allStatus: [],
            allReqPlatform: [],
            formData: {
                division: "",
                status: "5",
                pubstatus: "2", //默认查询生产发布
                searchKey: "",
                dept: "",
                realPlatform: "",
                deployType: "",
                empType: "",
                onboardStartDate: "",
                onboardEndDate: "",
                retireStartDate: "",
                retireEndDate: "",
            },
        });

        const packageForm = reactive({
            dtPackage: [],
            iShow: false, //显示更新包
            packageFile: {}, //更新包附件
            packageName: "",
            uploadTimes: 0, //可以上传次数
            selPublishId: "", //更新的ID
            isDisable: false,
        });

        const formInput = reactive({
            title: "新增上岗申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            processIDReadonly: true,
            userSelType: 2, //1 开发人员 2 业务人员
            allTechs: [], //技术组担当
            allScenes: [], //场景组担当
            planPlatform: [], //部署平台
            digitalTypes: [], //员工类型
            hqOptions: [], //所有总部
            formData: {
                Id: "",
                AuditStatus: "0",
                reqNo: "", //需求编号
                ProcessName: "",
                ProcessID: "",
                processDesc: "",
                sceneBussValue: "",
                CreateMan: "",
                CreateManName: "",
                division: "",
                empType: "",
                introduction: "",
                techUID: "",
                techName: "",
                sceneUID: "",
                sceneName: "",
                UserName: "",
                UserNameEmail: "",
                UserId: "",
                UserIDName: [],
                realPlatform: "", //部署平台
                otherPlatform: "", //其他部署平台
                PubState: "",
                empVersion: "", //数字员工版本
                ManSingleTime: "",
                ManFrequency: "",
                DevelopTime: "",
                RobotSingleTime: "",
                RobotMonthRun: "",
                SingleSaveTime: "",
                otherAppID: "",
                verHistory: "",
                MachineName: "",
                fPathPackage: "",
                fPathPdd: "",
                fPathPhoto: "",
                isPro: false, //是否生产发布
                difyViewType: "",
                difyViewDivsion: "",
                empNo: "",
                deployType: "",
                localReason: "",
                localAppPath: "",
                localExeFile: "",
                localExeParam: "",
                localAppType: "", //本地程序类型 1 python 2 exe 3excel
                operationNodes: "",
                replaceNodes: "",
            },
            formRules: {
                reqNo: [{ required: false, message: "需求编号不能为空" }],
                ProcessName: [
                    { required: true, message: "数字员工名称不能为空" },
                ],
                processDesc: [
                    { required: false, message: "工作场景描述不能为空" },
                ],
                sceneBussValue: [
                    { required: false, message: "场景业务价值不能为空" },
                ],
                empType: [{ required: true, message: "数字员工类型不能为空" }],
                introduction: [
                    { required: true, message: "数字员工简介不能为空" },
                ],
                techUID: [{ required: true, message: "辅导老师不能为空" }],
                sceneUID: [{ required: false, message: "场景组担当不能为空" }],
                UserNameEmail: [
                    { required: true, message: "业务人员不能为空" },
                ],
                PubState: [{ required: true, message: "发布阶段不能为空" }],
                empVersion: [
                    { required: true, message: "数字员工版本不能为空" },
                ],
                realPlatform: [{ required: true, message: "部署平台不能为空" }],
                otherPlatform: [{ required: false, message: "不能为空" }],
                ManSingleTime: [
                    {
                        required: false,
                        message: "Before-人工每次耗时(分钟)不能为空",
                    },
                ],
                ManFrequency: [
                    { required: false, message: "Before-人工每月次数不能为空" },
                ],
                DevelopTime: [{ required: false, message: "开发时长不能为空" }],
                RobotSingleTime: [
                    {
                        required: false,
                        message: "After-每次耗时(分钟)不能为空",
                    },
                ],
                RobotMonthRun: [
                    { required: false, message: "After-每月次数不能为空" },
                ],
                otherAppID: [{ required: false, message: "外部AppID不能为空" }],
                verHistory: [
                    { required: false, message: "版本变更备注不能为空" },
                ],
                fPathPackage: [{ required: true, message: "程序包不能为空" }],
                fPathPdd: [{ required: true, message: "设计文档不能为空" }],
                fPathPhoto: [
                    { required: false, message: "数字员工照片不能为空" },
                ],
                difyViewType: [
                    { required: false, message: "Dify员工公开范围不能为空" },
                ],
                difyViewDivsion: [
                    { required: false, message: "公开总部不能为空" },
                ],
                deployType: [{ required: true, message: "运行方式不能为空" }],
                localReason: [
                    { required: false, message: "本地运行原因不能为空" },
                ],
                localAppPath: [
                    { required: false, message: "本地应用程序路径不能为空" },
                ],
                localExeFile: [
                    { required: false, message: "本地可执行文件不能为空" },
                ],
                localExeParam: [
                    { required: false, message: "本地可执行文件参数不能为空" },
                ],
                localAppType: [
                    { required: false, message: "本地程序类型不能为空" },
                ],
                operationNodes: [
                    { required: false, message: "操作节点数不能为空" },
                ],
                replaceNodes: [
                    { required: false, message: "替代节点数不能为空" },
                ],
            },
        });
        const formInputRetire = reactive({
            title: "退役申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            userSelType: 3, // 科长
            formData: {
                Id: "",
                AuditStatus: "0",
                ProcessID: "",
                ProcessName: "",
                DevelopUser: "",
                DevelopUserUID: "",
                leader: "",
                leaderUID: "",
                retireReason: "",
                leaderIDName: [],
            },
            formRules: {
                ProcessID: [{ required: true, message: "开发编号不能为空" }],
                ProcessName: [
                    { required: true, message: "数字员工名称不能为空" },
                ],
                DevelopUser: [{ required: true, message: "开发人员不能为空" }],
                leader: [{ required: true, message: "科长不能为空" }],
                retireReason: [{ required: true, message: "退役原因不能为空" }],
            },
        });
        const formInputAddMan = reactive({
            title: "添加业务人员",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            userSelType: 4, // 添加业务人员
            formData: {
                Id: "",
                pubId: "",
                reqType: "1", //申请类型
                status: "0",
                processID: "",
                processName: "",
                developer: "",
                oldUserName: "",
                oldUserID: "",
                UserName: "",
                UserId: "",
                UserNameEmail: "",
                UserIDName: [],
                reqReason: "",
                creator: "",
            },
            formRules: {
                reqReason: [{ required: true, message: "申请原因不能为空" }],
                UserNameEmail: [
                    { required: true, message: "新业务人员不能为空" },
                ],
            },
        });
        const activeKey = ref("1");
        const fpestimateRef = ref(null);
        const changeApplyListRef = ref(null);
        const localAppTypeOptions = [
            {
                value: "1",
                label: "Python程序文件(.py)",
                tip: "",
            },
            {
                value: "2",
                label: "可执行文件(.exe)",
                tip: "",
            },
            {
                value: "3",
                label: "Excel宏(.xlsm、VBA等)",
                tip: "",
            },
            {
                value: "5",
                label: "其他编程语言",
                tip: "如 MATLAB、PLC、Android、TypeScript、VBS、.Net、Java等，请在【开发工具或语言】描述技术实现方式",
            },
            {
                value: "6",
                label: "咚咚应用",
                tip: "如咚咚AI表格、AI助理、咚咚OA审批流、Deap平台等，请在【外部AppID】填写访问链接",
            },
            {
                value: "7",
                label: "智能体",
                tip: "使用AI应用开发平台（如Coze、友答、AI Works、悟空等）创建的工作流、智能体、聊天助手等应用，请在【外部AppID】填写访问链接",
            },
            {
                value: "8",
                label: "其他业务系统",
                tip: "业务自主建设的应用系统（如网站、后台服务）等，请在【外部AppID】填写访问链接",
            },
            {
                value: "4",
                label: "其他",
                tip: "未在上述选项中，请在【开发工具或语言】描述技术实现方式",
            },
        ];
        return {
            tableData: null,
            tableDataHis: null,
            tablePager,
            userTablePager,
            updatePackagePager,
            toolbar,
            pageHeight,
            formInput,
            formInputRetire,
            formInputAddMan,
            dtUser: null,
            iShowSelectUser: ref(false),
            onePackageFile: {}, //上传的附件
            isShowPackageLink: false,
            onePDDFile: {}, //上传的附件
            isShowPDDLink: false,
            onePhotoFile: {}, //上传的附件
            isShowPhotoLink: false,
            dtAudit: [],
            isShowAuditList: false,
            isShowChangeApplyList: false,
            packageForm,
            isShowEditRow: false, //管理员编辑列
            isShowRequireSel: false, //发布申请，选择需求
            reqTablePager,
            dtReqs: [], //需求列表
            tableHeight: 0,
            submitting: false,
            activeKey,
            isViewFooter: false,
            otherPlatformLabel: "其他部署平台",
            isDifyDE: false,
            isShowDeployType: ref(false), //是否显示运行方式
            isShowLocalExeFile: ref(false), //是否显示本地执行文件
            isShowLocalExeParam: ref(false), //是否显示本地执行参数
            isShowLocalAppPath: ref(false), //是否显示本地应用程序路径
            localAppPathLabel: ref("Python.exe路径"),
            localExeFileLabel: ref("Python文件"),
            localExeParamLabel: ref("程序执行参数"),
            localAppPlaceholder: ref(
                "Python.exe 路径(如：C:\\Python\\python.exe)"
            ),
            localFilePlaceholder: ref(
                "Python脚本 路径(如：C:\\Python\\script.py)"
            ),
            fpestimateRef,
            historyDataFrequency: [],
            historyDataEmpType: [],
            changeApplyListRef,
            localAppTypeOptions,
        };
    },
    methods: {
        formatTime({ cellValue }) {
            return XEUtils.toDateString(cellValue, "yyyy-MM-dd");
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.division,
                    this.toolbar.formData.status,
                    this.toolbar.formData.pubstatus,
                    "",
                    this.toolbar.formData.realPlatform,
                    this.toolbar.formData.deployType,
                    this.toolbar.formData.empType,
                    this.toolbar.formData.onboardStartDate,
                    this.toolbar.formData.onboardEndDate,
                    this.toolbar.formData.retireStartDate,
                    this.toolbar.formData.retireEndDate,
                ],
            };
            this.$api.newPublishManageAPI
                .getTalentProfileList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        userListPageChange() {
            this.findUserData();
        },
        reqListPageChange() {
            this.findReqsData();
        },
        bindAllStatus() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: ["28"],
            };
            this.$api.systemManageAPI
                .getLookupValue(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.allStatus = [];
                    for (const item of res.data.Data) {
                        if (!["5", "6", "7"].includes(item.LookupValueCode)) {
                            continue;
                        }
                        this.toolbar.allStatus.push({
                            value: item.LookupValueCode,
                            label:
                                item.LookupValueName == "已审核"
                                    ? "已上岗"
                                    : item.LookupValueName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addAuditRecord(status, type) {
            let auditBuId = "";
            let auditOpinion = "";
            switch (type) {
                case "1":
                    auditBuId = this.formInput.formData.Id;
                    auditOpinion = "";
                    break;
                case "2":
                    auditBuId = this.formInputRetire.formData.Id;
                    auditOpinion = "数字员工退役发起";
                    break;
                case "3":
                    auditBuId = this.formInputAddMan.formData.Id;
                    auditOpinion = "添加业务使用人发起";
                    break;
            }
            //写审核日志
            const params = {
                auditBuId: auditBuId,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: auditOpinion,
                auditNode: "审核发起",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getLocalAppTypeTip(value) {
            const option = this.localAppTypeOptions.find(
                (item) => item.value === String(value)
            );

            return option?.tip || "";
        },
        bindPC() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: ["0"], //RPA
            };
            this.$api.systemManageAPI
                .getMachineListByType(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.RobotName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.division = "";
            this.toolbar.formData.realPlatform = "";
            this.toolbar.formData.deployType = "";
            this.toolbar.formData.empType = "";
            this.toolbar.formData.onboardStartDate = "";
            this.toolbar.formData.onboardEndDate = "";
            this.toolbar.formData.retireStartDate = "";
            this.toolbar.formData.retireEndDate = "";
        },
        //删除
        async removeRowEvent(row) {
            if (
                row.AuditStatus.includes("审核中") ||
                ["已审核", "已上岗", "退役中"].includes(row.AuditStatus)
            ) {
                await VXETable.modal.message({
                    content: "不能删除，请联系管理员",
                    status: "error",
                });
                return;
            }

            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                this.$api.newPublishManageAPI
                    .delPublish(
                        Qs.stringify({ publishId: row.Id, editType: "1" })
                    )
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });

                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        showFPEstimate(row) {
            this.$refs.fpestimateRef.openModal(
                row.reqId,
                row.ProcessName,
                true
            );
        },
        showChangeHis() {
            this.isShowChangeApplyList = true;
        },
        //管理员修改
        editAdminEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };
            this.$api.newPublishManageAPI
                .getPublishOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    this.formInput.formData.Id = res.data.Data.Id;
                    this.formInput.formData.empNo = res.data.Data.empNo;
                    this.formInput.formData.AuditStatus =
                        res.data.Data.AuditStatus;
                    this.formInput.formData.ProcessName =
                        res.data.Data.ProcessName;
                    this.formInput.formData.ProcessID = res.data.Data.ProcessID;
                    this.formInput.formData.reqNo = res.data.Data.reqNo;
                    this.formInput.formData.sceneBussValue =
                        res.data.Data.sceneBussValue;
                    this.formInput.formData.processDesc =
                        res.data.Data.processDesc;
                    this.formInput.formData.CreateMan = res.data.Data.CreateMan;
                    this.formInput.formData.CreateManName =
                        res.data.Data.CreateManName;
                    this.formInput.formData.division = res.data.Data.division;
                    this.formInput.formData.empType = res.data.Data.empType;
                    this.formInput.formData.introduction =
                        res.data.Data.introduction;
                    this.formInput.formData.techUID = res.data.Data.techUID;
                    this.formInput.formData.techName = res.data.Data.techName;
                    this.formInput.formData.sceneUID = res.data.Data.sceneUID;
                    this.formInput.formData.sceneName = res.data.Data.sceneName;
                    this.formInput.formData.UserName = res.data.Data.UserName;
                    this.formInput.formData.UserId = res.data.Data.UserId;
                    this.formInput.formData.UserNameEmail =
                        res.data.Data.UserNameEmail;
                    this.formInput.formData.otherAppID =
                        res.data.Data.otherAppID;
                    this.formInput.formData.UserNameEmail =
                        res.data.Data.UserNameEmail;
                    this.formInput.formData.realPlatform =
                        res.data.Data.realPlatform;
                    this.formInput.formData.otherPlatform =
                        res.data.Data.otherPlatform;
                    this.formInput.formData.PubState = res.data.Data.PubState;
                    this.formInput.formData.empVersion =
                        res.data.Data.empVersion;
                    this.formInput.formData.ManSingleTime =
                        res.data.Data.ManSingleTime;
                    this.formInput.formData.ManFrequency =
                        res.data.Data.ManFrequency;
                    this.formInput.formData.DevelopTime =
                        res.data.Data.DevelopTime;
                    this.formInput.formData.RobotSingleTime =
                        res.data.Data.RobotSingleTime;
                    this.formInput.formData.RobotMonthRun =
                        res.data.Data.RobotMonthRun;
                    this.formInput.formData.SingleSaveTime =
                        res.data.Data.SingleSaveTime;
                    this.formInput.formData.otherAppID =
                        res.data.Data.otherAppID;
                    this.formInput.formData.verHistory =
                        res.data.Data.verHistory;
                    this.formInput.formData.difyViewType =
                        res.data.Data.difyViewType;
                    this.formInput.formData.difyViewDivsion =
                        res.data.Data.difyViewDivsion.split(",");
                    this.formInput.formData.deployType =
                        res.data.Data.deployType;
                    this.formInput.formData.localReason =
                        res.data.Data.localReason;
                    this.formInput.formData.localAppPath =
                        res.data.Data.localAppPath;
                    this.formInput.formData.localExeFile =
                        res.data.Data.localExeFile;
                    this.formInput.formData.localExeParam =
                        res.data.Data.localExeParam;
                    this.formInput.formData.localAppType =
                        res.data.Data.localAppType;
                    this.formInput.formData.operationNodes =
                        res.data.Data.operationNodes;
                    this.formInput.formData.replaceNodes =
                        res.data.Data.replaceNodes;
                    this.onSelectPubState();
                    this.checkHasFiles();
                    this.onSelectDeployType();
                    this.formInput.formRules.fPathPackage[0].required = false;
                    this.formInput.formRules.fPathPdd[0].required = false;
                    this.formInput.formRules.fPathPhoto[0].required = false;
                    this.formInput.title = "查看数字员工档案";
                    this.submitting = false;
                    this.editType = "3"; //更新

                    this.formInput.allInputDisable = true;
                    this.formInput.saveButDisable = true;

                    let count =
                        this.formInput.formData.UserId.toString().split(
                            ";"
                        ).length;
                    this.formInput.formData.UserIDName = [];
                    for (let i = 0; i < count; i++) {
                        this.formInput.formData.UserIDName.push({
                            Name: this.formInput.formData.UserNameEmail.toString().split(
                                ";"
                            )[i],
                            ID: this.formInput.formData.UserId.toString().split(
                                ";"
                            )[i],
                        });
                    }
                    this.formInput.processIDReadonly = true;
                    this.setHistoryEmpType();
                    this.setHistoryFrequency();
                    this.activeKey = "1";
                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onDifyViewTypeChange() {
            this.formInput.formRules.difyViewDivsion[0].required =
                this.formInput.formData.difyViewType === "2";
        },
        //编辑数据
        editRowEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };
            this.$api.newPublishManageAPI
                .getPublishOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.formInput.formData.Id = res.data.Data.Id;
                    this.formInput.formData.AuditStatus =
                        res.data.Data.AuditStatus;
                    this.formInput.formData.ProcessName =
                        res.data.Data.ProcessName;
                    this.formInput.formData.ProcessID = res.data.Data.ProcessID;
                    this.formInput.formData.reqNo = res.data.Data.reqNo;
                    this.formInput.formData.sceneBussValue =
                        res.data.Data.sceneBussValue;
                    this.formInput.formData.processDesc =
                        res.data.Data.processDesc;
                    this.formInput.formData.CreateMan = res.data.Data.CreateMan;
                    this.formInput.formData.CreateManName =
                        res.data.Data.CreateManName;
                    this.formInput.formData.division = res.data.Data.division;
                    this.formInput.formData.empType = res.data.Data.empType;
                    this.formInput.formData.introduction =
                        res.data.Data.introduction;
                    this.formInput.formData.techUID = res.data.Data.techUID;
                    this.formInput.formData.techName = res.data.Data.techName;
                    this.formInput.formData.sceneUID = res.data.Data.sceneUID;
                    this.formInput.formData.sceneName = res.data.Data.sceneName;
                    this.formInput.formData.UserName = res.data.Data.UserName;
                    this.formInput.formData.UserId = res.data.Data.UserId;
                    this.formInput.formData.UserNameEmail =
                        res.data.Data.UserNameEmail;
                    this.formInput.formData.realPlatform =
                        res.data.Data.realPlatform;
                    this.formInput.formData.otherPlatform =
                        res.data.Data.otherPlatform;
                    this.formInput.formData.PubState = res.data.Data.PubState;
                    this.formInput.formData.empVersion =
                        res.data.Data.empVersion;
                    this.formInput.formData.ManSingleTime =
                        res.data.Data.ManSingleTime;
                    this.formInput.formData.ManFrequency =
                        res.data.Data.ManFrequency;
                    this.formInput.formData.DevelopTime =
                        res.data.Data.DevelopTime;
                    this.formInput.formData.RobotSingleTime =
                        res.data.Data.RobotSingleTime;
                    this.formInput.formData.RobotMonthRun =
                        res.data.Data.RobotMonthRun;
                    this.formInput.formData.SingleSaveTime =
                        res.data.Data.SingleSaveTime;
                    this.formInput.formData.otherAppID =
                        res.data.Data.otherAppID;
                    this.formInput.formData.verHistory =
                        res.data.Data.verHistory;
                    this.formInput.formData.difyViewType =
                        res.data.Data.difyViewType;
                    this.formInput.formData.difyViewDivsion =
                        res.data.Data.difyViewDivsion.split(",");
                    this.formInput.formData.operationNodes =
                        res.data.Data.operationNodes;
                    this.formInput.formData.replaceNodes =
                        res.data.Data.replaceNodes;
                    this.onSelectPubState();
                    this.checkHasFiles();
                    this.onSelectDeployType();
                    this.formInput.formRules.fPathPackage[0].required = false;
                    this.formInput.formRules.fPathPdd[0].required = false;
                    this.formInput.formRules.fPathPhoto[0].required = false;

                    this.editType = "2"; //更新
                    this.formInput.allInputDisable = true;
                    this.formInput.saveButDisable = true;
                    this.formInput.title = "查看数字员工档案";
                    this.isViewFooter = false;

                    let count =
                        this.formInput.formData.UserId.toString().split(
                            ";"
                        ).length;
                    this.formInput.formData.UserIDName = [];
                    for (let i = 0; i < count; i++) {
                        this.formInput.formData.UserIDName.push({
                            Name: this.formInput.formData.UserNameEmail.toString().split(
                                ";"
                            )[i],
                            ID: this.formInput.formData.UserId.toString().split(
                                ";"
                            )[i],
                        });
                    }
                    this.formInput.processIDReadonly = true;
                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        closeWinEvent() {
            this.findData();
        },
        selectUser(type) {
            this.formInput.userSelType = type;
            this.findUserData();
            this.iShowSelectUser = true;
        },
        selectReqs() {
            this.findReqsData();
            this.isShowRequireSel = true;
        },
        findReqsData() {
            const findStat = "5"; //已审核
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.reqTablePager.currentPage,
                pageSize: this.reqTablePager.pageSize,
                searchKey: [this.reqTablePager.searchKey, "1", findStat], //第1个参数，是按创建人查询
            };
            this.$api.newRequireManageAPI
                .getRequireList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtReqs = res.data.Data.dataTable;
                    this.reqTablePager.currentPage = res.data.Data.currentPage;
                    this.reqTablePager.pageSize = res.data.Data.pageSize;
                    this.reqTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        confirmSelectUser() {
            this.iShowSelectUser = false;
        },
        confirmSelectReq() {
            const $table = this.$refs.xTableReqs;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [record.Id],
            };
            this.$api.requireManageAPI
                .getRequireOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    let oneModel = res.data.Data.dataTable[0];
                    this.formInput.formData.ProcessName = oneModel.processName;
                    this.formInput.formData.ProcessID = oneModel.processID;
                    this.formInput.formData.reqNo = oneModel.requireNo;
                    this.formInput.formData.sceneBussValue =
                        oneModel.sceneBussValue;
                    this.formInput.formData.processDesc = oneModel.processDesc;
                    this.formInput.formData.techUID = oneModel.tutorUID;
                    this.formInput.formData.techName = oneModel.tutorName;
                    this.formInput.formData.realPlatform =
                        oneModel.planPlatform;
                })
                .catch((error) => {
                    console.log(error);
                });
            this.isShowRequireSel = false;
        },
        //删除用户
        clearUser(userid) {
            let idx = -1;
            this.formInput.formData.UserIDName.forEach(function (
                item,
                index,
                arr
            ) {
                if (item.ID == userid) {
                    idx = index;
                }
            });
            let tmpId = [],
                tmpname = [];
            tmpId = this.formInput.formData.UserId.toString().split(";");
            tmpname =
                this.formInput.formData.UserNameEmail.toString().split(";");
            tmpId.splice(idx, 1);
            tmpname.splice(idx, 1);
            this.formInput.formData.UserId = tmpId.join(";");
            this.formInput.formData.UserNameEmail = tmpname.join(";");
            let count = 0;
            if (this.formInput.formData.UserId.toString() != "") {
                count =
                    this.formInput.formData.UserId.toString().split(";").length;
            }
            this.formInput.formData.UserIDName = [];
            //debugger
            for (let i = 0; i < count; i++) {
                this.formInput.formData.UserIDName.push({
                    Name: this.formInput.formData.UserNameEmail.toString().split(
                        ";"
                    )[i],
                    ID: this.formInput.formData.UserId.toString().split(";")[i],
                });
            }
        },
        //删除新增业务人员
        clearUserAddMan(userid) {
            let idx = -1;
            this.formInputAddMan.formData.UserIDName.forEach(function (
                item,
                index,
                arr
            ) {
                if (item.ID == userid) {
                    idx = index;
                }
            });
            let tmpId = [],
                tmpname = [];
            tmpId = this.formInputAddMan.formData.UserId.toString().split(";");
            tmpname =
                this.formInputAddMan.formData.UserNameEmail.toString().split(
                    ";"
                );
            tmpId.splice(idx, 1);
            tmpname.splice(idx, 1);
            this.formInputAddMan.formData.UserId = tmpId.join(";");
            this.formInputAddMan.formData.UserNameEmail = tmpname.join(";");
            let count = 0;
            if (this.formInputAddMan.formData.UserId.toString() != "") {
                count =
                    this.formInputAddMan.formData.UserId.toString().split(
                        ";"
                    ).length;
            }
            this.formInputAddMan.formData.UserIDName = [];
            //debugger
            for (let i = 0; i < count; i++) {
                this.formInputAddMan.formData.UserIDName.push({
                    Name: this.formInputAddMan.formData.UserNameEmail.toString().split(
                        ";"
                    )[i],
                    ID: this.formInputAddMan.formData.UserId.toString().split(
                        ";"
                    )[i],
                });
            }
        },
        //选择用户
        chooseUser() {
            const $table = this.$refs.xTableUser;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            //选开发人员
            if (this.formInput.userSelType === 1) {
                this.formInput.formData.DevelopUser =
                    record.UserName + "(" + record.UserMail + ")";
                this.formInput.formData.DevelopUserUID = record.Id;
                this.formInput.formData.DevelopIDName = [];
                this.formInput.formData.DevelopIDName.push({
                    Name: this.formInput.formData.DevelopUser,
                    ID: this.formInput.formData.DevelopUserUID,
                });

                //选业务人员
            } else if (this.formInput.userSelType === 2) {
                //判断是否已选择过
                if (this.formInput.formData.UserId.toString() != "") {
                    for (let item of this.formInput.formData.UserId.toString().split(
                        ";"
                    )) {
                        if (item == record.Id) {
                            VXETable.modal.message({
                                content: "该人员已选择",
                                status: "warning",
                            });
                            return;
                        }
                    }
                }

                if (
                    this.formInput.formData.UserNameEmail == null ||
                    this.formInput.formData.UserNameEmail == ""
                ) {
                    this.formInput.formData.UserNameEmail =
                        record.UserName + "(" + record.UserMail + ")";
                } else {
                    this.formInput.formData.UserNameEmail +=
                        ";" + record.UserName + "(" + record.UserMail + ")";
                }
                if (
                    this.formInput.formData.UserId == null ||
                    this.formInput.formData.UserId == ""
                ) {
                    this.formInput.formData.UserId = record.Id;
                } else {
                    this.formInput.formData.UserId += ";" + record.Id;
                }
                let count =
                    this.formInput.formData.UserId.toString().split(";").length;
                this.formInput.formData.UserIDName = [];
                for (let i = 0; i < count; i++) {
                    this.formInput.formData.UserIDName.push({
                        Name: this.formInput.formData.UserNameEmail.toString().split(
                            ";"
                        )[i],
                        ID: this.formInput.formData.UserId.toString().split(
                            ";"
                        )[i],
                    });
                }
                //选择退役审批科长
            } else if (this.formInput.userSelType == 3) {
                this.formInputRetire.formData.leader =
                    record.UserName + "(" + record.UserMail + ")";
                this.formInputRetire.formData.leaderUID = record.Id;
                this.formInputRetire.formData.leaderIDName = [];
                this.formInputRetire.formData.leaderIDName.push({
                    Name: this.formInputRetire.formData.leader,
                    ID: this.formInputRetire.formData.leaderUID,
                });
            } else {
                //判断是否已选择过
                if (this.formInputAddMan.formData.UserId.toString() != "") {
                    for (let item of this.formInputAddMan.formData.UserId.toString().split(
                        ";"
                    )) {
                        if (item == record.Id) {
                            VXETable.modal.message({
                                content: "该人员已选择",
                                status: "warning",
                            });
                            return;
                        }
                    }
                }
                if (this.formInputAddMan.formData.oldUserID != "") {
                    for (let item of this.formInputAddMan.formData.oldUserID
                        .toString()
                        .split(";")) {
                        if (item == record.Id) {
                            VXETable.modal.message({
                                content: "该人员在原业务人员已选择",
                                status: "warning",
                            });
                            return;
                        }
                    }
                }
                if (
                    this.formInputAddMan.formData.UserNameEmail == null ||
                    this.formInputAddMan.formData.UserNameEmail == ""
                ) {
                    this.formInputAddMan.formData.UserNameEmail =
                        record.UserName + "(" + record.UserMail + ")";
                } else {
                    this.formInputAddMan.formData.UserNameEmail +=
                        ";" + record.UserName + "(" + record.UserMail + ")";
                }
                if (
                    this.formInputAddMan.formData.UserId == null ||
                    this.formInputAddMan.formData.UserId == ""
                ) {
                    this.formInputAddMan.formData.UserId = record.Id;
                } else {
                    this.formInputAddMan.formData.UserId += ";" + record.Id;
                }

                let count =
                    this.formInputAddMan.formData.UserId.toString().split(
                        ";"
                    ).length;
                this.formInputAddMan.formData.UserIDName = [];
                for (let i = 0; i < count; i++) {
                    this.formInputAddMan.formData.UserIDName.push({
                        Name: this.formInputAddMan.formData.UserNameEmail.toString().split(
                            ";"
                        )[i],
                        ID: this.formInputAddMan.formData.UserId.toString().split(
                            ";"
                        )[i],
                    });
                }
            }
        },
        getModel() {
            const data = new FormData();
            data.append("filePackage", this.onePackageFile);
            data.append("filePdd", this.onePDDFile);
            data.append("filePhoto", this.onePhotoFile);
            data.append("Id", this.formInput.formData.Id);
            data.append("fPathPackage", this.formInput.formData.fPathPackage);
            data.append("fPathPdd", this.formInput.formData.fPathPdd);
            data.append("fPathPhoto", this.formInput.formData.fPathPhoto);
            data.append("reqNo", this.formInput.formData.reqNo);
            data.append("ProcessName", this.formInput.formData.ProcessName);
            data.append("ProcessID", this.formInput.formData.ProcessID);
            data.append("processDesc", this.formInput.formData.processDesc);
            data.append(
                "sceneBussValue",
                this.formInput.formData.sceneBussValue
            );
            data.append("CreateMan", this.getUserUID);
            data.append("division", this.formInput.formData.division);
            data.append("AuditStatus", this.formInput.formData.AuditStatus);
            data.append("UserId", this.formInput.formData.UserId);
            data.append("PubState", this.formInput.formData.PubState);
            data.append("empType", this.formInput.formData.empType);
            data.append("introduction", this.formInput.formData.introduction);
            data.append("techUID", this.formInput.formData.techUID);
            data.append("techName", this.getTechName);
            data.append("sceneUID", this.formInput.formData.sceneUID);
            data.append("sceneName", this.getSceneName);
            data.append("ManSingleTime", this.formInput.formData.ManSingleTime);
            data.append("ManFrequency", this.formInput.formData.ManFrequency);
            data.append("DevelopTime", this.formInput.formData.DevelopTime);
            data.append(
                "RobotSingleTime",
                this.formInput.formData.RobotSingleTime
            );
            data.append("RobotMonthRun", this.formInput.formData.RobotMonthRun);
            data.append("createUserId", this.$store.state.userID);
            data.append("MachineName", this.formInput.formData.MachineName);
            data.append("realPlatform", this.formInput.formData.realPlatform);
            data.append("otherPlatform", this.formInput.formData.otherPlatform);
            data.append("empVersion", this.formInput.formData.empVersion);
            data.append(
                "SingleSaveTime",
                this.formInput.formData.SingleSaveTime
            );
            data.append("otherAppID", this.formInput.formData.otherAppID);
            data.append("verHistory", this.formInput.formData.verHistory);
            data.append("DevelopUser", this.getUserName);
            data.append("DevelopUserUID", this.getUserId);
            data.append("difyViewType", this.formInput.formData.difyViewType);
            data.append(
                "difyViewDivsion",
                this.formInput.formData.difyViewDivsion
            );
            data.append("empNo", this.formInput.formData.empNo);

            return data;
        },
        findUserData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.userTablePager.currentPage,
                pageSize: this.userTablePager.pageSize,
                searchKey: [this.userTablePager.searchKey],
            };
            this.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtUser = res.data.Data.dataTable;
                    this.userTablePager.currentPage = res.data.Data.currentPage;
                    this.userTablePager.pageSize = res.data.Data.pageSize;
                    this.userTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updatePackageListPageChange() {
            this.findPackageData();
        },
        findPackageData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.updatePackagePager.currentPage,
                pageSize: this.updatePackagePager.pageSize,
                searchKey: [this.packageForm.selPublishId],
            };
            this.$api.newPublishManageAPI
                .getPackageList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.packageForm.dtPackage = res.data.Data.dataTable;
                    this.updatePackagePager.currentPage =
                        res.data.Data.currentPage;
                    this.updatePackagePager.pageSize = res.data.Data.pageSize;
                    this.updatePackagePager.totalResult =
                        res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        exportDataEvent() {
            const $table = this.$refs.xTable1;
            $table.exportData({ type: "csv" });
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        onSelectPubState() {
            //测试发布
            if (this.formInput.formData.PubState === "1") {
                this.formInput.formData.isPro = false;
                if (this.editType == "1") {
                    //新增时校验
                    this.formInput.formRules.fPathPackage[0].required = true;
                    this.formInput.formRules.fPathPdd[0].required = true;
                }
                this.formInput.formRules.fPathPhoto[0].required = false;
                this.formInput.formRules.ManSingleTime[0].required = false;
                this.formInput.formRules.ManFrequency[0].required = false;
                this.formInput.formRules.DevelopTime[0].required = false;
                this.formInput.formRules.RobotSingleTime[0].required = false;
                this.formInput.formRules.RobotMonthRun[0].required = false;
                this.formInput.formRules.operationNodes[0].required = false;
                this.formInput.formRules.replaceNodes[0].required = false;
                this.formInput.formData.ManSingleTime = 0;
                this.formInput.formData.ManFrequency = 0;
                this.formInput.formData.DevelopTime = 0;
                this.formInput.formData.RobotSingleTime = 0;
                this.formInput.formData.RobotMonthRun = 0;
            } else {
                this.formInput.formData.isPro = true;

                if (this.editType == "1") {
                    this.formInput.formRules.fPathPhoto[0].required = true;
                    this.formInput.formRules.fPathPackage[0].required = true;
                    this.formInput.formRules.fPathPdd[0].required = true;
                }

                this.formInput.formRules.ManSingleTime[0].required = true;
                this.formInput.formRules.ManFrequency[0].required = true;
                this.formInput.formRules.DevelopTime[0].required = true;
                this.formInput.formRules.RobotSingleTime[0].required = true;
                this.formInput.formRules.RobotMonthRun[0].required = true;
                this.formInput.formRules.operationNodes[0].required = true;
                this.formInput.formRules.replaceNodes[0].required = true;
            }
            //选其他部署平台，就要必填其他部署平台
            this.formInput.formRules.otherPlatform[0].required =
                this.formInput.formData.realPlatform === "PT006" ||
                this.formInput.formData.realPlatform === "PT003";
            //选Dify就填外部APPID
            this.formInput.formRules.otherAppID[0].required =
                this.formInput.formData.realPlatform === "PT003";
            this.otherPlatformLabel =
                this.formInput.formData.realPlatform === "PT003"
                    ? "Dify链接"
                    : "其他部署平台";
            this.isDifyDE = this.formInput.formData.realPlatform === "PT003";
            this.formInput.formRules.difyViewType[0].required =
                this.formInput.formData.realPlatform === "PT003";
            this.formInput.formRules.difyViewDivsion[0].required =
                this.formInput.formData.realPlatform === "PT003";
        },
        async insertPackageEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fPathPackage = file.name;
                this.onePackageFile = file;
            });
        },
        async insertPDDEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fPathPdd = file.name;
                this.onePDDFile = file;
            });
        },
        async insertPhotoEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fPathPhoto = file.name;
                this.onePhotoFile = file;
            });
        },

        downloadFile(type) {
            this.$api.fileManageAPI
                .downloadPublishFile(
                    Qs.stringify({
                        publishId: this.formInput.formData.Id,
                        type: type,
                    })
                )
                .then(async (res) => {
                    const contentType = res.headers["content-type"] || "";

                    // 后端返回错误JSON
                    if (contentType.includes("application/json")) {
                        const text = await res.data.text();

                        try {
                            const result = JSON.parse(text);

                            VXETable.modal.alert({
                                content: result.Message || "下载失败",
                                status: "error",
                            });
                        } catch (e) {
                            VXETable.modal.alert({
                                content: text,
                                status: "error",
                            });
                        }

                        return;
                    }

                    let fileName = "下载文件";

                    const disposition =
                        res.headers["content-disposition"] ||
                        res.headers["Content-Disposition"];

                    if (disposition) {
                        const utf8Match = disposition.match(
                            /filename\*=UTF-8''([^;]+)/i
                        );

                        const normalMatch =
                            disposition.match(/filename="?([^"]+)"?/i);

                        if (utf8Match && utf8Match[1]) {
                            fileName = decodeURIComponent(utf8Match[1]);
                        } else if (normalMatch && normalMatch[1]) {
                            fileName = decodeURIComponent(normalMatch[1]);
                        }
                    }

                    const blob = new Blob([res.data], {
                        type: contentType || "application/octet-stream",
                    });

                    if (blob.size === 0) {
                        VXETable.modal.alert({
                            content: "文件内容为空",
                            status: "error",
                        });
                        return;
                    }

                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement("a");
                    a.href = url;
                    a.download = fileName;
                    a.style.display = "none";

                    document.body.appendChild(a);

                    a.click();

                    document.body.removeChild(a);

                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error(error);

                    VXETable.modal.alert({
                        content: "文件下载失败",
                        status: "error",
                    });
                });
        },
        checkHasFiles() {
            this.$api.newPublishManageAPI
                .checkPublishHasFiles(
                    Qs.stringify({
                        publishId: this.formInput.formData.Id,
                        type: "",
                    })
                )
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.alert({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    let fileStatus = res.data.Data.split(",");

                    this.isShowPackageLink = fileStatus[0] === "1";
                    this.isShowPDDLink = fileStatus[1] === "1";
                    this.isShowPhotoLink = fileStatus[2] === "1";
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateSingleSaveTime() {
            this.formInput.formData.SingleSaveTime =
                this.formInput.formData.ManSingleTime -
                this.formInput.formData.RobotSingleTime;
        },
        bindTechMember() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getTechMemberList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.allTechs = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.allTechs.push({
                            value: item.uid,
                            label: item.userName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindSceneMember() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getSceneMemberList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.allScenes = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.allScenes.push({
                            value: item.uid,
                            label: item.userName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPlatform() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDeployPlatformList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.planPlatform = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.planPlatform.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindDigitalType() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getDigitalMemberTypeList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    this.formInput.digitalTypes = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.digitalTypes.push({
                            value: item.code,
                            label: item.name,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindHQ() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 50,
                searchKey: [""],
            };
            this.$api.digitalDictManageAPI
                .getHeadquarterList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        console.log(res.data.Message);
                        return;
                    }
                    // console.log(res.data.Data);
                    this.formInput.hqOptions = [];
                    for (const item of res.data.Data.dataTable) {
                        this.formInput.hqOptions.push({
                            value: item.hqCode,
                            label: item.hqName,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onSelectDeployType() {
            //平台运行
            if (this.formInput.formData.deployType === "平台") {
                this.formInput.formRules.localReason[0].required = false;
                this.formInput.formRules.localAppType[0].required = false;
                this.formInput.formData.localReason = "";
                this.isShowDeployType = false;
            } else if (this.formInput.formData.deployType === "本地") {
                this.formInput.formRules.localReason[0].required = true;
                this.formInput.formRules.localAppType[0].required = true;
                this.isShowDeployType = true;
            }
            // python exe excel
            this.onSelectLocalAppType();
        },

        onSelectLocalAppType() {
            if (this.formInput.formData.localAppType === "1") {
                this.localAppPathLabel = "Python.exe路径";
                this.localExeFileLabel = "Python文件";
                this.localExeParamLabel = "程序执行参数";
                this.localAppPlaceholder =
                    "Python.exe 路径(如：C:\\Python\\python.exe)";
                this.localFilePlaceholder =
                    "Python脚本 路径(如：C:\\Python\\script.py)";
                this.isShowLocalExeFile = true;
                this.isShowLocalExeParam = true;
                this.isShowLocalAppPath = true;
                this.formInput.formRules.localAppPath[0].required = true;
                this.formInput.formRules.localAppPath[0].message =
                    "请输入Python.exe程序路径";
                this.formInput.formRules.localExeFile[0].required = true;
                this.formInput.formRules.localExeFile[0].message =
                    "请输入Python文件路径";
            } else if (this.formInput.formData.localAppType === "2") {
                //Exe
                this.localAppPathLabel = "Exe程序路径";
                this.localExeFileLabel = "Exe程序路径";
                this.localExeParamLabel = "程序执行参数";
                this.localAppPlaceholder =
                    "Exe程序路径(如：C:\\Program Files\\MyApp\\app.exe)";
                this.localFilePlaceholder =
                    "Exe程序路径(如：C:\\Program Files\\MyApp\\app.exe)";
                this.formInput.formData.localExeFile = "";
                this.isShowLocalExeFile = false;
                this.isShowLocalExeParam = true;
                this.isShowLocalAppPath = true;
                this.formInput.formRules.localAppPath[0].required = true;
                this.formInput.formRules.localAppPath[0].message =
                    "请输入Exe程序路径";
                this.formInput.formRules.localExeFile[0].required = false;
                this.formInput.formRules.localExeFile[0].message =
                    "请输入Exe程序路径";
            } else if (this.formInput.formData.localAppType === "3") {
                //Excel
                this.localAppPathLabel = "Excel程序路径";
                this.localExeFileLabel = "Excel文件";
                this.localExeParamLabel = "Excel参数";
                this.localAppPlaceholder =
                    "Excel程序路径(如：C:\\Program Files\\MyApp\\Excel.exe)";
                this.localFilePlaceholder =
                    "Excel文件路径(如：C:\\Program Files\\MyApp\\file.xlsx)";
                this.formInput.formData.localExeParam = "";
                this.isShowLocalExeFile = true;
                this.isShowLocalExeParam = false;
                this.isShowLocalAppPath = true;
                this.formInput.formRules.localAppPath[0].required = true;
                this.formInput.formRules.localAppPath[0].message =
                    "请输入Excel.exe程序路径";
                this.formInput.formRules.localExeFile[0].required = true;
                this.formInput.formRules.localExeFile[0].message =
                    "请输入Excel文件路径";
            } else {
                //其他
                this.localAppPathLabel = "程序路径";
                this.localExeFileLabel = "文件路径";
                this.localExeParamLabel = "执行参数";
                this.localAppPlaceholder =
                    "程序路径(如：C:\\Program Files\\MyApp\\app.exe)";
                this.localFilePlaceholder =
                    "文件路径(如：C:\\Program Files\\MyApp\\file.exe)";
                this.formInput.formData.localExeParam = "";
                this.isShowLocalExeFile = false;
                this.isShowLocalExeParam = false;
                this.isShowLocalAppPath = false;
                this.formInput.formRules.localAppPath[0].required = false;
                this.formInput.formRules.localExeFile[0].required = false;
            }
            if (this.formInput.formData.deployType === "本地") {
                if (
                    this.formInput.formData.localAppType === "5" ||
                    this.formInput.formData.localAppType === "4"
                ) {
                    this.formInput.formRules.otherPlatform[0].required = true;
                    this.formInput.formRules.otherAppID[0].required = false;
                } else if (this.formInput.formData.localAppType === "6") {
                    this.formInput.formRules.otherAppID[0].required = true;
                    this.formInput.formRules.otherPlatform[0].required = false;
                } else if (this.formInput.formData.localAppType === "7") {
                    this.formInput.formRules.otherAppID[0].required = true;
                    this.formInput.formRules.otherPlatform[0].required = false;
                } else if (this.formInput.formData.localAppType === "8") {
                    this.formInput.formRules.otherAppID[0].required = true;
                    this.formInput.formRules.otherPlatform[0].required = false;
                } else {
                    this.formInput.formRules.otherPlatform[0].required = false;
                    this.formInput.formRules.otherAppID[0].required = false;
                }
            } else {
                this.formInput.formRules.otherPlatform[0].required = false;
                this.formInput.formRules.otherAppID[0].required = false;
            }
        },
        setHistoryEmpType() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 50,
                searchKey: [this.formInput.formData.Id, "2"],
            };
            this.$api.newPublishManageAPI
                .getPublishInfoChange(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        console.log(res.data.Message);
                        return;
                    }
                    // console.log(res.data.Data);
                    this.historyDataEmpType = res.data.Data.dataTable;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setHistoryFrequency() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 50,
                searchKey: [this.formInput.formData.Id, "1"],
            };
            this.$api.newPublishManageAPI
                .getPublishInfoChange(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        console.log(res.data.Message);
                        return;
                    }
                    // console.log(res.data.Data.dataTable);
                    this.historyDataFrequency = res.data.Data.dataTable;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.bindPC();
        this.bindHQ();
        this.bindAllStatus();
        this.bindTechMember();
        this.bindSceneMember();
        this.bindPlatform();
        this.bindDigitalType();
        this.findData();

        window.addEventListener("keydown", this.keydown);
    },
    created() {
        this.isShowEditRow = this.$store.state.isAdmin === "1";
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
    computed: {
        getUserName() {
            return this.$store.state.userName;
        },
        getJobZb() {
            return this.$store.state.jobZb;
        },
        getJobName() {
            return this.$store.state.jobName;
        },
        getUserEmail() {
            return this.$store.state.email;
        },
        getUserUID() {
            return this.$store.state.userID;
        },
        getUserId() {
            return this.$store.state.Id;
        },
        getTechName() {
            const selected = this.formInput.allTechs.find(
                (t) => t.value === this.formInput.formData.techUID
            );
            return selected ? selected.label : "";
        },
        getSceneName() {
            const selected = this.formInput.allScenes.find(
                (t) => t.value === this.formInput.formData.sceneUID
            );
            return selected ? selected.label : "";
        },
    },
};
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
